import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class HomeMobileMapShellStateService {
  private readonly headerOpacitySignal = signal(0);

  readonly headerOpacity = this.headerOpacitySignal.asReadonly();

  setHeaderOpacity(value: number): void {
    if (!Number.isFinite(value)) {
      this.headerOpacitySignal.set(0);
      return;
    }

    const clamped = Math.max(0, Math.min(1, value));
    this.headerOpacitySignal.set(Math.round(clamped * 100) / 100);
  }

  reset(): void {
    this.headerOpacitySignal.set(0);
  }
}
